// 网络问题原因归属map
export const problemList = {
  1: '网络组',
  2: '直播保障组',
  3: 'IT组'
}
